import { render, staticRenderFns } from "./Bookmarksbar.vue?vue&type=template&id=c298035e&scoped=true"
import script from "./Bookmarksbar.vue?vue&type=script&lang=js"
export * from "./Bookmarksbar.vue?vue&type=script&lang=js"
import style0 from "./Bookmarksbar.vue?vue&type=style&index=0&id=c298035e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c298035e",
  null
  
)

export default component.exports